/**
 * Типы, которые понимает tryon-service (как в бэкенде).
 */
export const TRYON_UPPER = [
  'Худи',
  'Джемперы',
  'Лонгсливы',
  'Свитера',
  'Куртки',
  'Рюкзаки',
  'Футболки',
];
export const TRYON_LOWER = ['Штаны', 'Джинсы', 'Шорты'];
export const TRYON_SHOES = ['Кроссовки'];

/** ID типов из API для слота примерки (верх / низ / обувь). */
export function itemTypeIdsForTryonSlot(allTypes, slot) {
  if (!slot || !Array.isArray(allTypes)) return [];
  const names =
    slot === 'upper' ? TRYON_UPPER : slot === 'lower' ? TRYON_LOWER : TRYON_SHOES;
  const wanted = new Set(names.map((n) => n.toLowerCase()));
  return allTypes
    .filter((t) => {
      const c = canonicalTryonType(t?.name);
      return c && wanted.has(c.toLowerCase());
    })
    .map((t) => t.id);
}

const ALIASES = {
  футболка: 'Футболки',
  худи: 'Худи',
  джемпер: 'Джемперы',
  джемперы: 'Джемперы',
  лонгслив: 'Лонгсливы',
  свитер: 'Свитера',
  свитера: 'Свитера',
  куртка: 'Куртки',
  куртки: 'Куртки',
  рюкзак: 'Рюкзаки',
  рюкзаки: 'Рюкзаки',
  штаны: 'Штаны',
  джинсы: 'Джинсы',
  шорты: 'Шорты',
  кроссовки: 'Кроссовки',
  кроссовок: 'Кроссовки',
};

/** Каноническое имя типа для API или null */
export function canonicalTryonType(apiName) {
  if (!apiName || typeof apiName !== 'string') return null;
  const k = apiName.trim().toLowerCase();
  if (ALIASES[k]) return ALIASES[k];
  const all = [...TRYON_UPPER, ...TRYON_LOWER, ...TRYON_SHOES];
  const hit = all.find((t) => t.toLowerCase() === k);
  return hit || null;
}

export function tryonStageForItem(item) {
  const c = canonicalTryonType(item?.item_type);
  if (!c) return null;
  if (TRYON_UPPER.includes(c)) return 'upper';
  if (TRYON_LOWER.includes(c)) return 'lower';
  if (TRYON_SHOES.includes(c)) return 'shoes';
  return null;
}

export function absolutePhotoUrl(item) {
  const p = item?.photos?.[0]?.file_path;
  if (!p) return null;
  if (typeof window === 'undefined') return p;
  if (/^https?:\/\//i.test(p)) return p;
  const path = String(p).replace(/^\/+/, '');
  return `${window.location.origin}/${path}`;
}
